
import { combineReducers } from "redux"
import { 
    initialProvisionedCLientsSearchQuery,
    initialLogListingSearchQuery,
    initialSensorListingQuery
 } from "../constants";


function SensorManagerReducer() {
    const clients = (state = [], action) => {

        const { type, payload } = action;

        switch (type) {
            case 'GET_PROVISIONED_CLIENTS_INIT':
                return [];
            case 'GET_PROVISIONED_CLIENTS_SUCCESS':
                return payload;
            default:
                return state;
        }
    }

    const logs = (state = [], action) => {

        const { type, payload } = action;

        switch (type) {
            case 'GET_CLIENTS_LOGS_INIT':
                return [];
            case 'GET_CLIENTS_LOGS_SUCCESS':
                return payload;
            default:
                return state;
        }
    }
    
    const clientSensors = (state = [], action) => {

        const { type, payload } = action;

        switch (type) {
            case 'GET_CLIENT_SENSORS_INIT':
                return [];
            case 'GET_CLIENT_SENSORS_SUCCESS':
                return payload;
            case 'UPDATE_CLIENT_SENSOR':
                return payload;
            case 'DELETE_CLIENT_SENSOR':
                return payload;
            default:
                return state;
        }
    }

    const clientsSearchQuery = (state = initialProvisionedCLientsSearchQuery, action) => {

        const { type, payload } = action;

        switch (type) {
            case 'SET_PROVISIONED_CLIENTS_SEARCH_QUERY_INIT':
                return initialProvisionedCLientsSearchQuery;
            case 'SET_PROVISIONED_CLIENTS_SEARCH_QUERY':
                return payload;
            default:
                return state;
        }
    }

    const logsSearchQuery = (state = initialLogListingSearchQuery, action) => {

        const { type, payload } = action;

        switch (type) {
            case 'SET_CLIENT_LOGS_SEARCH_QUERY_INIT':
                return initialLogListingSearchQuery;
            case 'SET_CLIENT_LOGS_SEARCH_QUERY':
                return payload;
            default:
                return state;
        }
    }

    const sensorSearchQuery = (state = initialSensorListingQuery, action) => {

        const { type, payload } = action;

        switch (type) {
            case 'SET_CLIENT_SENSORS_SEARCH_QUERY_INIT':
                return initialSensorListingQuery;
            case 'SET_CLIENT_SENSORS_SEARCH_QUERY':
                return payload;
            default:
                return state;
        }
    }

    return combineReducers({
        clients,
        clientsSearchQuery,
        logs,
        logsSearchQuery,
        clientSensors,
        sensorSearchQuery
    })
}

export default SensorManagerReducer();